<div class="modal-footer">
  <button type="button" class="btn action-btn" [ngStyle]="{ 'background-color': submitColor, 'border-color': submitColor }" [disabled]="submitDisabled" (click)="submit.emit()">{{ submitText }}</button>
  <button type="button" class="btn btn-default md-close" (click)="cancel.emit()">{{ cancelText }}</button>
</div>
